import * as decorators from "./decorators";

export function useDecorator(decorator, data) {
  return decorators[decorator](data);
}
